module.exports = __webpack_public_path__ + "media/situs inversus.d8589f91.wav";